"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockHandle = void 0;
const container_definitions_1 = require("@fluidframework/container-definitions");
/**
 * Mock implementation of IFluidHandle.
 */
class MockHandle {
    constructor(value, path = `mock-handle-${Math.random().toString(36).slice(2)}`, absolutePath = `/${path}`) {
        this.value = value;
        this.path = path;
        this.absolutePath = absolutePath;
        this.graphAttachState = container_definitions_1.AttachState.Detached;
    }
    get IFluidHandle() { return this; }
    get isAttached() { return this.graphAttachState === container_definitions_1.AttachState.Attached; }
    async get() { return this.value; }
    attachGraph() { this.graphAttachState = container_definitions_1.AttachState.Attached; }
    bind() { throw Error("MockHandle.bind() unimplemented."); }
}
exports.MockHandle = MockHandle;
//# sourceMappingURL=mockHandle.js.map